/**
 * 我的主页
 * @returns
 */
import {
  Box,
  Image,
  Tabs,
  TabList,
  Tab,
  TabIndicator,
  TabPanels,
  TabPanel,
  InputGroup,
  InputRightElement,
  Input,
  Flex,
  HStack,
  Text,
  Select,
  useDisclosure,
  useToast,
  Button,
} from "@chakra-ui/react";
import React, { useState, useEffect } from "react";
import Masonry from "react-responsive-masonry";
import InfiniteScroll from "react-infinite-scroll-component";
import MyHeader from "@/components/usercenter/myheader";
import ContentUnit from "@/components/content";
import { SlMagnifier } from "react-icons/sl";
import { Content, Classic, LikeOrCollect } from "@/types/content";
import Publish from "@/components/publish";
import {
  useLazyGetContentsQuery,
  useGetClassicsQuery,
  useLazyLikeContentsQuery,
  useLazyCollectContentsQuery,
  useLazyGetHistoryQuery,
  useLikeContentMutation,
  useCollectContentMutation,
  useLazyGetPersonalContentsQuery,
} from "@/services/api/endpoints/content";
import { useSelector, useDispatch } from "react-redux";
import { updateUser, selectUser } from "@/reducer/userslice";
import { ServerError } from "@/types/errors";
import { translate } from "@/utils/utils";
import { useNavigate, useParams } from "react-router-dom";
import emptyImg from "@/assets/images/empty.png";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { selectMode, updateDesign, updateRefStructure, updateRefStyle } from "@/reducer/modeslice";
import { DesignParameter, LoraModel } from "@/types/design";
import { BigModeImages } from "@/components/design/big_modal_images";
import { SmallModeImages } from "@/components/design/small_modal_images";
import { Tags } from "@/components/design/prompt";
import { NegTags } from "@/components/design/negtive_prompt";

const PER_PAGE_DEFAULT = 60;

const generateType: Record<string, string> = {
  decoration: "室内设计",
  architecture: "建筑设计",
  landscape: "景观设计",
  plane: "规划设计",
  general: "其他",
};

const MyHomePage = () => {
  const PublishControl = useDisclosure();
  const toast = useToast();
  const items = Array(100).fill(null);
  const [allContents, setAllContents] = useState<Content[]>([]);
  const [hasMore, setHasMore] = useState(true);
  const [searchValue, setSearchValue] = useState("");
  // const [classic, setClassic] = useState<Classic[]>([]);
  const [classic, setClassic] = useState<string[]>([
    "全部",
    "建筑设计",
    "规划设计",
    "室内设计",
    "景观设计",
    "其他",
  ]);
  const [tabIndex, setTabIndex] = useState(0);
  const [currentClassIndex, setCurrentClassIndex] = useState(0);
  const [currentContentId, setCurrentContentId] = useState("");
  const [page, setPage] = useState(0);
  const [beginTime, setBeginTime] = useState("");
  const [endTime, setEndTime] = useState("");
  // const { data: classicList } = useGetClassicsQuery({});

  const user = useSelector(selectUser);
  // console.log(user);

  const userId = user.id;

  const params = useParams();

  const dispatch = useAppDispatch();
  const { design } = useAppSelector(selectMode);
  const { addTags } = Tags();
  const { addTag } = NegTags();
  const navigate = useNavigate();

  const [getPersonalContents] = useLazyGetPersonalContentsQuery();
  const [getCollectContents, { data: collectContents }] =
    useLazyCollectContentsQuery();
  const [getLikeContents, { data: likeContents }] = useLazyLikeContentsQuery();
  const [getHistoryContents, { data: historyContents }] =
    useLazyGetHistoryQuery();

  const [likeContent] = useLikeContentMutation();
  const [collectContent] = useCollectContentMutation();

  const handleChangeTab = (index: number) => {
    setTabIndex(index);
    if (index === 0) {
      setAllContents([]);
      setCurrentClassIndex(0);
      setHasMore(true);
      setPage(0);
      fetchData();
    }
    if (index === 1) {
      getCollectContents(userId);
    }
    if (index === 2) {
      getLikeContents(userId);
    }
    if (index === 3) {
      getHistoryContents(userId);
    }
  };

  const handleChangeSearchValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value);
  };

  const fetchData = async () => {
    const classicName = translate(classic[currentClassIndex]) || "all";
    const result = await getPersonalContents({
      page: page,
      per_page: PER_PAGE_DEFAULT,
      classicName: classicName,
      userId: userId,
    });
    const contents = result.data;

    if (
      contents &&
      (contents.length === 0 || contents.length < PER_PAGE_DEFAULT)
    ) {
      setHasMore(false);
      if (page == 0) {
        setAllContents([...contents]);
      } else {
        setAllContents([...allContents, ...contents]);
      }
    } else if (contents) {
      if (page == 0) {
        setAllContents([...contents]);
      } else {
        setAllContents([...allContents, ...contents]);
      }
      setPage(page + 1);
    }
  };
  useEffect(() => {
    fetchData();
  }, [currentClassIndex]);

  // useEffect(() => {
  //   if (classicList) {
  //     const all: Classic = { classic_name: "全部", id: "0", classic_order: 0 };
  //     const result = [all, ...classicList];
  //     setClassic(result);
  //   }
  // }, [classicList]);

  const handleClick = (id: string) => {
    setCurrentContentId(id);
    PublishControl.onOpen();
  };

  const handleOneClcik = (content: Content) => {
    // console.log(design)

    let newdesign = {
      ...design,
      mode: content.mode || "新手模式",
      generatetype: generateType[content.generate_type],
      width: content.width,
      height: content.height,
      seed: content.seed,
      steps: content.steps,
      cfgscale: content.cfgscale || 7,
      prompt: content.prompt,
      negativeprompt: content.negative_prompt,
      type: content.type,
      vaemodel: content.vae || "",
    } as DesignParameter;

    // 大模型反向匹配
    if (content.sd_model_checkpoint) {
      const bigmodel = BigModeImages.filter(
        (item) => item.realname === content.sd_model_checkpoint
      );
      newdesign.bigmodel = bigmodel[0];
    }
    // 小模型反向匹配
    if (content.lora) {
      const smallModes = content.lora;
      let smallmodel: LoraModel[] = [];
      const keys = Object.keys(smallModes);
      keys.map((keyitem) => {
        let Lora = SmallModeImages.filter(
          (item) => item.loraname === keyitem
        )[0];
        Lora.weight = smallModes[keyitem];
        smallmodel.push(Lora);
      });
      newdesign.smallmodel = smallmodel;
    }

    dispatch(updateDesign(newdesign));

    const refstructure = content.ref_structure
      ? [
          {
            url: content.ref_structure,
            weight: 1,
            refStructureType: content.ref_structure_type, //参照结构类型
            control_mode: content.control_mode || "My prompt is more important",
          },
        ]
      : [];
    dispatch(updateRefStructure(refstructure));

    const refstyle = content.ref_style
      ? [
          {
            url: content.ref_style,
            weight: 1,
          },
        ]
      : [];
    dispatch(updateRefStyle(refstyle));

    console.log(newdesign);

    if (content.prompt) {
      const tags = content.prompt.split(",");
      addTags(tags);
    }
    if (content.negative_prompt) {
      const tags = content.prompt.split(",");
      const negtags = content.negative_prompt.split(",");
      negtags.map((item) => addTag(item));
    }

    navigate("/ai/design"); // 切换到生图页
  };

  const handleOnLike = async (content: Content) => {
    console.log(">>>>>>>>>>123");
    const likeData: LikeOrCollect = {
      content_id: content.id,
      user_id: userId,
      status: !content.is_like,
    };

    const res = await likeContent(likeData)
      .unwrap()
      .catch((e) => {
        toast({
          title: (e as ServerError).message,
          position: "top",
          status: "error",
          duration: 2000,
          isClosable: true,
        });
      });
      if(res && tabIndex===0){
        const newAllContents = allContents.map(item=>{
          if(item.id === content.id){
            return {
              ...item,
              is_like: !item.is_like,
              like_num: item.is_like? item.like_num-1 : item.like_num+1
            }
          }
          return item;
        })
        setAllContents([...newAllContents]);
        // getLikeContents(userId)
        // updateUserInfo();
      }
  };
  const handleOnCollect = async (content: Content) => {
    const collectData: LikeOrCollect = {
      content_id: content.id,
      user_id: userId,
      status: !content.is_collect,
    };

    const res = await collectContent(collectData)
      .unwrap()
      .catch((e) => {
        toast({
          title: (e as ServerError).message,
          position: "top",
          status: "error",
          duration: 2000,
          isClosable: true,
        });
      });
      if(res && tabIndex===0){
        const newAllContents = allContents.map(item=>{
          if(item.id === content.id){
            return {
              ...item,
              is_collect: !item.is_collect,
              collect_num:item.is_collect? item.collect_num-1 : item.collect_num+1
            }
          }
          return item;
        })
        setAllContents([...newAllContents]);
        // updateUserInfo();
        
      }
  };
  const handChangeClassic = (index: number) => {
    if (index === currentClassIndex) {
      setAllContents([]);
      fetchData();
    } else {
      setAllContents([]);
      setCurrentClassIndex(index);
      setHasMore(true);
      setPage(0);
    }
    
  };

  const handleChangeBeginTime = (e: React.ChangeEvent<HTMLInputElement>) => {
    setBeginTime(e.target.value);
  };
  const handleChangeEndTime = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEndTime(e.target.value);
  };

  return (
    <Box overflow={"hidden"}>
      <MyHeader userId={params.id}></MyHeader>
      <Box width="80%" m="0 auto">
        <Tabs
          mt="12px"
          position="relative"
          variant="unstyled"
          onChange={handleChangeTab}
        >
          <Flex
            h="52px"
            justifyContent={"space-between"}
            borderBottom={"1px solid #E0E0E0"}
          >
            <TabList fontSize={"18px"} color="#8E94A9">
              <Tab _selected={{ color: "#27314D", fontWeight: "bold" }}>
                AI创作
              </Tab>
              <Tab _selected={{ color: "#27314D", fontWeight: "bold" }}>
                收藏
              </Tab>
              <Tab _selected={{ color: "#27314D", fontWeight: "bold" }}>
                点赞
              </Tab>
              <Tab _selected={{ color: "#27314D", fontWeight: "bold" }}>
                浏览记录
              </Tab>
            </TabList>
            <InputGroup flex={1} maxW="400px">
              <Input
                h="40px"
                // w="400px"
                boxSizing="border-box"
                border="1px solid #CBD1DF"
                borderRadius={0}
                bg="none"
                color={"#8E94A9"}
                fontSize="12px"
                placeholder="请输入"
                size="md"
                value={searchValue}
                onChange={handleChangeSearchValue}
              />
              <InputRightElement>
                <SlMagnifier color="#CBD1DF" />
              </InputRightElement>
            </InputGroup>
          </Flex>
          <TabIndicator
            mt="-1.5px"
            height="2px"
            bg="#27314D"
            borderRadius="1px"
          />
          <Flex
            pt={"1rem"}
            pl="1rem"
            pr="1rem"
            justifyContent={"space-between"}
            alignItems="center"
            flexWrap={"wrap"}
          >
            <Box mb="5px">
              {tabIndex === 0 && (
                <Flex alignItems={"center"} gap="22px">
                  {classic.map((item, index) => (
                    <Box
                      key={index}
                      color={
                        currentClassIndex === index ? "#27314D" : "#8E94A9"
                      }
                      bg={currentClassIndex === index ? "#DCE0EB" : "none"}
                      fontSize="12px"
                      p="2px 6px"
                      cursor={"pointer"}
                      onClick={() => handChangeClassic(index)}
                    >
                      {item}
                    </Box>
                  ))}
                </Flex>
              )}
            </Box>

            {tabIndex === 0 && (
              <Flex mb="5px">
                <HStack mr={"18px"}>
                  <Text fontSize={"12px"} color="#8E94A9">
                    排序：
                  </Text>
                  <Select
                    color={"#27314D"}
                    fontSize={"12px"}
                    border="none"
                    w="80px"
                    size="xs"
                    placeholder="请选择"
                  >
                    <option value=" 微信">最新发布</option>
                  </Select>
                </HStack>
                <HStack mr={"18px"}>
                  <Text fontSize={"12px"} color="#8E94A9">
                    作品范围：
                  </Text>
                  <Select
                    color={"#27314D"}
                    fontSize={"12px"}
                    border="none"
                    w="80px"
                    size="xs"
                    placeholder="请选择"
                  >
                    <option value=" 微信">全部作品</option>
                  </Select>
                </HStack>
                <HStack mr={"30px"}>
                  <Text fontSize={"12px"} color="#8E94A9">
                    选择分组：
                  </Text>
                  <Select
                    color={"#27314D"}
                    fontSize={"12px"}
                    border="none"
                    w="80px"
                    size="xs"
                    placeholder="请选择"
                  >
                    <option value=" 微信">全部分组</option>
                  </Select>
                </HStack>
              </Flex>
            )}

            {tabIndex === 3 && (
              <Flex mb="5px">
                <HStack mr={"18px"} spacing="18px">
                  <Button
                    ml="6px"
                    borderRadius={"0"}
                    width={"56px"}
                    height={"29px"}
                    color="#8E94A9"
                    bgColor="rgba(238, 241, 247, 0.5)"
                    fontWeight={"normal"}
                    fontSize="12px"
                    _hover={{
                      bgColor: "rgba(238, 241, 247, 0.5)",
                      color: "#8E94A9",
                    }}
                  >
                    今天
                  </Button>
                  <Button
                    ml="6px"
                    borderRadius={"0"}
                    width={"68px"}
                    height={"29px"}
                    color="#8E94A9"
                    bgColor="rgba(238, 241, 247, 0.5)"
                    fontWeight={"normal"}
                    fontSize="12px"
                    _hover={{
                      bgColor: "rgba(238, 241, 247, 0.5)",
                      color: "#8E94A9",
                    }}
                  >
                    近一周
                  </Button>
                  <Button
                    ml="6px"
                    borderRadius={"0"}
                    width={"80px"}
                    height={"29px"}
                    color="#8E94A9"
                    bgColor="rgba(238, 241, 247, 0.5)"
                    fontWeight={"normal"}
                    fontSize="12px"
                    _hover={{
                      bgColor: "rgba(238, 241, 247, 0.5)",
                      color: "#8E94A9",
                    }}
                  >
                    近一个月
                  </Button>
                </HStack>
                <HStack spacing={0}>
                  <Input
                    border="1px solid #DCE0EB"
                    placeholder="请选择"
                    w="110px"
                    fontSize={"12px"}
                    color={"#8E94A9"}
                    size="sm"
                    type="date"
                    value={beginTime}
                    onChange={handleChangeBeginTime}
                  />
                  <Text color={"#DCE0EB"}>—</Text>
                  <Input
                    border="1px solid #DCE0EB"
                    placeholder="请选择"
                    w="110px"
                    fontSize={"12px"}
                    color={"#8E94A9"}
                    size="sm"
                    type="date"
                    value={endTime}
                    onChange={handleChangeEndTime}
                  />
                  <Button
                    ml="6px"
                    borderRadius={"0"}
                    width={"56px"}
                    height={"29px"}
                    color="#FFFFFF"
                    bgColor="#496AE1"
                    fontWeight={"normal"}
                    fontSize="12px"
                    _hover={{
                      bgColor: "#3F5BC1",
                      color: "#E6E6E6",
                    }}
                  >
                    确定
                  </Button>
                </HStack>
              </Flex>
            )}
          </Flex>
          <TabPanels>
            {/* AI创作 */}
            <TabPanel>
              {!allContents.length && !hasMore && (
                <Flex
                  h="calc(100vh - 500px)"
                  flexDir={"column"}
                  justifyContent="center"
                  alignItems={"center"}
                  minH="150px"
                >
                  <Image h="120px" src={emptyImg} />
                  <Box fontSize={"14px"} color={"#8E94A9"}>
                    目前您还没有AI创作作品～
                  </Box>
                </Flex>
              )}
              <InfiniteScroll
                dataLength={allContents.length}
                next={fetchData}
                hasMore={hasMore}
                loader={<h4>Loading...</h4>}
              >
                {allContents && (
                  <Masonry>
                    {allContents.map((item, index) => (
                      <Box p="3px" boxSizing="border-box" key={item.id}>
                        {/* 渲染每个项目的内容 */}
                        {/* Item {index} */}
                        <ContentUnit
                          content={item}
                          onClick={() => handleClick(item.id)}
                          onOneClick={() => handleOneClcik(item)}
                          onLike={() => handleOnLike(item)}
                          onCollect={() => handleOnCollect(item)}
                        />
                      </Box>
                    ))}
                  </Masonry>
                )}
              </InfiniteScroll>
            </TabPanel>
            {/* 收藏 */}
            <TabPanel>
              <Box>
                {!collectContents?.length && (
                  <Flex
                    h="calc(100vh - 500px)"
                    minH="150px"
                    flexDir={"column"}
                    justifyContent="center"
                    alignItems={"center"}
                  >
                    <Image h="120px" src={emptyImg} />
                    <Box fontSize={"14px"} color={"#8E94A9"}>
                      您还没有收藏内容～
                    </Box>
                  </Flex>
                )}
                {collectContents && (
                  <Masonry>
                    {collectContents.map((item) => (
                      <Box p="3px" boxSizing="border-box" key={item.id}>
                        {/* 渲染每个项目的内容 */}
                        {/* Item {index} */}
                        <ContentUnit
                          content={item}
                          onClick={() => handleClick(item.id)}
                          onOneClick={() => handleOneClcik(item)}
                          onLike={() => handleOnLike(item)}
                          onCollect={() => handleOnCollect(item)}
                        />
                      </Box>
                    ))}
                  </Masonry>
                )}
              </Box>
            </TabPanel>
            {/* 点赞 */}
            <TabPanel>
              <Box>
                {!likeContents?.length && (
                  <Flex
                    h="calc(100vh - 500px)"
                    minH="150px"
                    flexDir={"column"}
                    justifyContent="center"
                    alignItems={"center"}
                  >
                    <Image h="120px" src={emptyImg} />
                    <Box fontSize={"14px"} color={"#8E94A9"}>
                      您还没有点赞的内容～
                    </Box>
                  </Flex>
                )}
                {likeContents && (
                  <Masonry>
                    {likeContents.map((item, index) => (
                      <Box p="3px" boxSizing="border-box" key={item.id}>
                        {/* 渲染每个项目的内容 */}
                        {/* Item {index} */}
                        <ContentUnit
                          content={item}
                          onClick={() => handleClick(item.id)}
                          onOneClick={() => handleOneClcik(item)}
                          onLike={() => handleOnLike(item)}
                          onCollect={() => handleOnCollect(item)}
                        />
                      </Box>
                    ))}
                  </Masonry>
                )}
              </Box>
            </TabPanel>
            {/* 浏览记录 */}
            <TabPanel>
              <Box>
                {!historyContents?.length && (
                  <Flex
                    h="calc(100vh - 500px)"
                    minH="150px"
                    flexDir={"column"}
                    justifyContent="center"
                    alignItems={"center"}
                  >
                    <Image h="120px" src={emptyImg} />
                    <Box fontSize={"14px"} color={"#8E94A9"}>
                      您还没有浏览内容～
                    </Box>
                  </Flex>
                )}
                {historyContents && (
                  <Masonry>
                    {historyContents.map((item, index) => (
                      <Box p="3px" boxSizing="border-box" key={index}>
                        {/* 渲染每个项目的内容 */}
                        {/* Item {index} */}
                        <ContentUnit
                          content={item}
                          onClick={() => handleClick(item.id)}
                          onOneClick={() => handleOneClcik(item)}
                          onLike={() => handleOnLike(item)}
                          onCollect={() => handleOnCollect(item)}
                        />
                      </Box>
                    ))}
                  </Masonry>
                )}
              </Box>
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Box>
      <Publish
        isOpen={PublishControl.isOpen}
        onClose={PublishControl.onClose}
        contentId={currentContentId}
      />
    </Box>
  );
};

export default MyHomePage;
